import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { UploadProgress } from '../../types/file.ts';

export interface UIState {
  loadingStates: Record<string, boolean>;
  uploadProgress: UploadProgress | null;
  isRedirecting: boolean;
  showPaywall: boolean;
  showTutorials: boolean;
}

const initialState: UIState = {
  loadingStates: {},
  uploadProgress: null,
  isRedirecting: false,
  showPaywall: false,
  showTutorials: false,
};

export const uiReducer = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setLoading: (state: UIState, action: PayloadAction<{ key: string; isLoading: boolean }>) => {
      const { key, isLoading } = action.payload;
      state.loadingStates[key] = isLoading;
    },
    setUploadProgress: (state: UIState, action: PayloadAction<UploadProgress | null>) => {
      state.uploadProgress = action.payload;
    },
    setIsRedirecting: (state: UIState, action: PayloadAction<boolean>) => {
      state.isRedirecting = action.payload;
    },
    setShowPaywall: (state: UIState, action: PayloadAction<boolean>) => {
      state.showPaywall = action.payload;
    },
    setShowTutorials: (state: UIState, action: PayloadAction<boolean>) => {
      state.showTutorials = action.payload;
    },
  },
});
